var Ribbon = Ribbon || {};
exports.FSRibbon = Ribbon

/** @type String Selector for tabs holder. */
Ribbon.tabsHolder = '.tabs-holder li';

/** @type String Selector for groups holder. */
Ribbon.groupsHolder = '.groups-holder';

/** @type String Selector for groups toggle button. */
Ribbon.toggleBtn = '#toggleBtn';

/** @type String Key to session storage */
Ribbon.buttonDropDownOpenKey = 'buttonDropDown';

/** @type String Slector for components 'drop down' */
Ribbon.dropDown = '.ribbon-buttonDropDown';

/**
 * @returns void
 */
exports.init = function ()
{
	//add event on the newly-active just-shown tab
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		if ($(Ribbon.groupsHolder).is(':hidden'))
		{
			Ribbon.toggleGroupsHolder();
		}
	});

	//add event on click tabs
	$(Ribbon.tabsHolder).on('click', function () {
		if ($(this).hasClass('active'))
		{
			Ribbon.toggleGroupsHolder();
		}
	});

	//add event on click toggle button
	$(Ribbon.toggleBtn).on('click', function () {
		Ribbon.toggleGroupsHolder();
	});

	//add event on DropDown shown
	$(Ribbon.dropDown).on('shown.bs.dropdown', function (e) {
		sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, true);
	});

	//add event on DropDown hide
	$(Ribbon.dropDown).on('hide.bs.dropdown', function (e) {
		sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, false);
	});

	//add event on DropDown hover
	$(Ribbon.dropDown).hover(function (e) {
		if (sessionStorage.getItem(Ribbon.buttonDropDownOpenKey) === 'true')
		{
			$('.ribbon-buttonDropDown').removeClass('open');
			$(this).addClass('open');
		}
	});

	//fallback for svg logo in IE
    if (navigator.userAgent.match(/Trident/) && $('.fs-logo').length && $('.fs-logo').attr('src').match(/.svg$/)){
        $('.fs-logo').load(function(){ $('.fs-logo').closest('a').width($('.fs-logo').width()+20); });
        $('.fs-logo').closest('a').width($('.fs-logo').width()+20);
    }

    //apply ribbon state
    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();
    if (typeof ribbon_state['visibility'] != 'undefined' && ribbon_state['visibility'] == false){
        $(Ribbon.groupsHolder).hide();
        $(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
        $(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');
        $('body').css('padding-top', '57px');
    }
};

/**
 * @returns void
 */
Ribbon.toggleGroupsHolder = function ()
{
	$(Ribbon.groupsHolder).toggle();
    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();

	//toggle icon
	if ($(Ribbon.toggleBtn + ' span').hasClass('glyphicon-menu-up'))
	{
		$(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
		$(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');

        ribbon_state['visibility'] = false;
    	$('body').css('padding-top', '57px');
	}
	else
	{
		$(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-down');
		$(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-up');

        ribbon_state['visibility'] = true;
		$('body').css('padding-top', '133px');
	}

    window.localStorage.setItem('ribbon_state', JSON.stringify(ribbon_state));
};


Ribbon.updateTabsHolder = function (){
    var totalWidth = $($('.tabs-holder')[0]).width();
    var bodyWidth = $('#tabs-holder-cover').width();

    $('#tabs-holder-cover .tabs-holder').css('left', 0);

    if (totalWidth > bodyWidth && !isLayoutMobile()){
        if (!$('#tabs-holder-cover .tabMoveButton').length){
            $('#tabs-holder-cover').prepend('<a href="#" class="tabMoveButton tabLeftButton"><span class="glyphicon glyphicon-menu-right"></span></a>');
            $('#tabs-holder-cover').prepend('<a href="#" class="tabMoveButton tabRightButton"><span class="glyphicon glyphicon-menu-left"></span></a>');
        }

        var status = JSON.parse(window.sessionStorage.getItem('ribbon-tab-holder-status'));
        if (status){
            window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(true));
            $('#tabs-holder-cover .tabLeftButton').hide();
            $('#tabs-holder-cover .tabRightButton').show();
            $('#tabs-holder-cover .tabs-holder').css({ left: '-'+(totalWidth-bodyWidth+$('#tabs-holder-cover .tabRightButton').outerWidth())+'px' });
        }else{
            window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(false));
            $('#tabs-holder-cover .tabLeftButton').show();
            $('#tabs-holder-cover .tabRightButton').hide();
        }
    }else{
        $('#tabs-holder-cover .tabMoveButton').remove();
    }
};

Ribbon.updateGroupsHolder = function (){
    var id = $('.groups-holder .active').attr('id');
    var totalWidth = 30;
    var bodyWidth = $('body').width();
    $('.groups-holder .active .ribbon-group').each(function(){
        totalWidth += $(this).outerWidth();
    });

    $('.groups-holder .active').css('left', 0);

    if (totalWidth > bodyWidth && !isLayoutMobile()){
        if (!$('.groups-holder .groupMoveButton').length){
            $('.groups-holder').prepend('<a href="#" class="groupMoveButton groupLeftButton"><span class="glyphicon glyphicon-menu-right"></span></a>');
            $('.groups-holder').prepend('<a href="#" class="groupMoveButton groupRightButton"><span class="glyphicon glyphicon-menu-left"></span></a>');
        }

        var status = JSON.parse(window.sessionStorage.getItem('ribbon-group-holder-status'));
        if (status && status.length && status[0] == id && status[1] == 1){
            window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 1]));
            $('.groupLeftButton').hide();
            $('.groupRightButton').show();
            $('.groups-holder .active').css({ left: '-'+(totalWidth-bodyWidth+$('.groupRightButton').outerWidth())+'px' });
		}else{
            window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 0]));
        	$('.groupLeftButton').show();
            $('.groupRightButton').hide();
		}
    }else{
        $('.groups-holder .groupMoveButton').remove();
    }
};

$(document).on('shown.bs.tab', '.ribbon .tabs-holder a[href]', function(){
    window.sessionStorage.removeItem('ribbon-group-holder-status');
    Ribbon.updateGroupsHolder();
});

$(window).resize(function(){
    Ribbon.updateTabsHolder();
    Ribbon.updateGroupsHolder();
});

$(document).ready(function(){
    Ribbon.updateTabsHolder();
    Ribbon.updateGroupsHolder();
});

$(document).on('click','.tabLeftButton',function(event)
{
    event.preventDefault();

    var totalWidth = $($('.tabs-holder')[0]).width();
    var bodyWidth = $('#tabs-holder-cover').width();

    $(this).hide();
    $(this).parent().children('.tabRightButton').show();
    $('#tabs-holder-cover .tabs-holder').animate({ left: '-'+(totalWidth-bodyWidth+$(this).parent().children('.tabRightButton').outerWidth())+'px' }, 500);

    window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(true));
});

$(document).on('click','.tabRightButton',function(event)
{
    event.preventDefault();

    $(this).hide();
    $(this).parent().children('.tabLeftButton').show();
    $('#tabs-holder-cover .tabs-holder').animate({ left: 0 }, 500);

    window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(false));
});

$(document).on('click','.groupLeftButton',function(event)
{
    event.preventDefault();

    var totalWidth = 30;
    var bodyWidth = $('body').width();
    $('.groups-holder .active .ribbon-group').each(function(){
        totalWidth += $(this).outerWidth();
    });

    $(this).hide();
    $('.groupRightButton').show();
    $('.groups-holder .active').animate({ left: '-'+(totalWidth-bodyWidth+$('.groupRightButton').outerWidth())+'px' }, 500);

    var id = $('.groups-holder .active').attr('id');
    window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 1]));
});

$(document).on('click','.groupRightButton',function(event)
{
    event.preventDefault();

    $(this).hide();
    $(this).parent().children('.groupLeftButton').show();
    $('.groups-holder .active').animate({ left: 0 }, 500);

    var id = $('.groups-holder .active').attr('id');
    window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 0]));
});


// WEBPACK FOOTER //
// ./client-side/Ribbon/js/ribbon.js